module.exports = __webpack_public_path__ + "img/drag.28f37d1e.svg";